import { inject } from '@angular/core'
import { CanActivateFn, Router } from '@angular/router'

export const numericIdGuard: CanActivateFn = route => {
  const router = inject(Router)
  const id = route.paramMap.get('id') ?? route.paramMap.get('idConcurso')
  if (id && /^\d+$/.test(id)) return true
  router.navigate(['/404'])
  return false
}
